import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectGolfSchools } from './redux/selectors';
import { hasMsAdminAccess } from '../../redux/selectors';

import Loading from '../../../common/components/Loading';
import Icon from '../../../common/icons/Icon';
import Carousel from './carousel/Carousel';

class GolfSchools extends Component {
  renderHero = () => {
    return (
      <div className="hero__wrapper gs__hero__wrapper">
        <div className="container">
          <div className="gs__back">
            <Link to="/subscription/coaching">
              <span className="button__back-button">
                <Icon icon="BackArrow" />Back to Additional Coaching
              </span>
            </Link>
          </div>
          <div className="gs__hero">
            <h1>Tathata Golf Schools</h1>
            <h3>A Learning Environment Like No Other In The World</h3>
            <h4>Nestled in the Heart of Scottsdale, AZ at The Tathata Training Center</h4>
          </div>
        </div>
      </div>
    );
  };

  renderContent = schools => {
    const { hasMsAdminAccess } = this.props;
    const schoolCards = [];

    schools.data.forEach((school, key) => {
      console.log(school);
      if (school.name !== 'Movement Specialist Schools' || hasMsAdminAccess) {
        schoolCards.push(
          <div className="gs__card" key={key}>
            <div className="gs__card-content">
              <div
                className="gs__card__image"
                style={{ backgroundImage: `url(${school.image_url})` }}
              >
                {!school.name.includes("On Tour") && (
                  <span className="gs__card__image--mapmarker">
                    <Icon icon="MapMarker" /> In {school.location}
                  </span>
                )}
              </div>
              <h2>{school.name}</h2>
              <div className="gs__card--bullets">
                {school.highlights.summary_points &&
                  school.highlights.summary_points
                    // NOTE: locally it was already an array (LA)
                    // .split('\n')
                    .map((summary_points, i) => (
                      <p key={i}>{summary_points}</p>
                    ))}
                {/* {school.highlights.summary_points.map((point, key) => (
                  <div className="gs__card--bullet" key={key}>
                    <Icon icon="CheckmarkCircle" />
                    {point}
                  </div>
                ))} */}
              </div>
            </div>
            <Link
              className="button gs__card--btn"
              to={`/subscription/coaching/golf-schools/${school.id}`}
            >
              Learn More
            </Link>
          </div>
        );
      }
    });
    return <div className="gs__content">{schoolCards}</div>;
  };

  render() {
    const { schools } = this.props;

    if (!schools.loaded) {
      return <Loading />;
    }

    return (
      <div className="gs__wrapper">
        {this.renderHero()}
        <Carousel />
        {this.renderContent(schools)}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  hasMsAdminAccess: hasMsAdminAccess(state),
  schools: selectGolfSchools(state),
});

export default connect(mapStateToProps)(GolfSchools);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/GolfSchoolsList.js